import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

const ConfirmRemoveTagModal = ({
    show,
    onClose,
    onConfirm,
    itemName,
    tagName,
    isRemovingGroup = false
}) => {
    const [removeFromEverywhere, setRemoveFromEverywhere] = useState(false);

    // Reset state when modal opens
    useEffect(() => {
        if (show) {
            setRemoveFromEverywhere(false);
        }
    }, [show]);

    // If we are just removing a group, the "everywhere" logic might not apply or be different.
    // But the requirement is about removing APP/GAME from a group.

    // Logic: 
    // If tagName is present (we are in a group), allow choice.
    // If tagName is null (we are in "All Apps"), then it is always "removeFromEverywhere" (untrack), 
    // so we might not need to show the checkbox, or show it checked and disabled.

    const showCheckbox = !!tagName;

    const handleConfirm = () => {
        onConfirm({ removeFromEverywhere });
    };

    return (
        <Modal show={show} onHide={onClose} centered backdropClassName="modal-backdrop-custom">
            <div
                style={{
                    background: "#21222D",
                    color: "#fff",
                    borderRadius: 16,
                    padding: 32,
                    textAlign: "center",
                    boxShadow: "0 4px 32px #0007",
                    border: 'none'
                }}
            >
                <div
                    style={{
                        fontWeight: 600,
                        fontSize: 20,
                        marginBottom: 8,
                    }}
                >
                    {tagName
                        ? `Remove "${itemName}" from "${tagName}"?`
                        : `Untrack "${itemName}"?`
                    }
                </div>
                <div
                    style={{
                        color: "#A1ACB8",
                        marginBottom: 24,
                        fontSize: 14,
                        lineHeight: 1.5
                    }}
                >
                    {tagName
                        ? `Are you sure you want to remove this app from the group "${tagName}"?`
                        : `Are you sure you want to remove this app from your tracked list? This action can't be undone.`
                    }
                </div>

                {showCheckbox && (
                    <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}>
                            <input
                                type="checkbox"
                                checked={removeFromEverywhere}
                                onChange={(e) => setRemoveFromEverywhere(e.target.checked)}
                                style={{ width: 16, height: 16, accentColor: '#F6255A', cursor: 'pointer' }}
                            />
                            <span style={{ color: '#fff' }}>Remove from everywhere</span>
                        </label>
                    </div>
                )}

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 16,
                    }}
                >
                    <button
                        style={{
                            background: "#171821",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            padding: "10px 22px",
                            fontWeight: 500,
                            cursor: "pointer",
                        }}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        style={{
                            background: "#F6255A",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            padding: "10px 22px",
                            fontWeight: 500,
                            cursor: "pointer",
                        }}
                        onClick={handleConfirm}
                    >
                        Remove
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmRemoveTagModal;
